/* eslint-disable no-alert */
/* eslint-disable class-methods-use-this */
import store from 'store';
import history from '../routes/history';
import {
  LOCAL_STORAGE_AUTH_KEY
} from '../config/constants';
// eslint-disable-next-line import/no-cycle
import { postAppointmentAll } from '../utils/helpers';

export default class AuthGuestLoggedin {
  constructor() {
    this.loggedIn = this.loggedIn.bind(this);
    this.redirectSpeakDoctor = this.redirectSpeakDoctor.bind(this);
  }

  loggedIn() {
    const expiresAt = store.get(LOCAL_STORAGE_AUTH_KEY.EXPIRES_AT);
    return expiresAt !== undefined && (new Date().getTime() < expiresAt)
  }

  redirectSpeakDoctor = async () => {
    if (this.loggedIn()) {
      const { checkOk } = await postAppointmentAll()
      if (checkOk) {
        history.push('/speak-doctor')
      }
    } else {
      history.push('/sign-up/guest');
    }
  }
}
